import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "notifications" ]

  connect() {
    this.token = document.querySelector(
      'meta[name="csrf-token"]'
    ).content;
  };
}
